export type ExamSectionStatIndexView = {
  section_type: ExamSectionType;
  completed: boolean;
  course_id: number;
};

export type ExamSectionType = 'Online::ExamWritingSection' | 'Online::ExamPracticalSection';

export const ExamSectionWritingType = 'Online::ExamWritingSection';
export const ExamSectionPracticalType = 'Online::ExamPracticalSection';
